// extracted by mini-css-extract-plugin
module.exports = {"Categories":"NewsPostCategories_Categories__qthGp","Category":"NewsPostCategories_Category__a9re_","active":"NewsPostCategories_active__fsCSO"};